module.exports = {"451021100":"田州镇","451021101":"那坡镇","451021102":"坡洪镇","451021103":"那满镇","451021104":"百育镇","451021105":"玉凤镇","451021106":"头塘镇","451021107":"五村镇","451021108":"洞靖镇","451021204":"巴别乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451021.json
// module id = 2270
// module chunks = 0